import { useContext } from 'react';

import { TableContext } from '../contexts';

// ----------------------------------------------------------------------

const useTable = () => {
  const context = useContext(TableContext);

  if (!context) throw new Error('Table context must be use inside TableProvider');

  return context;
};

export default useTable;
